import React from "react";

class FormRadioButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={"checkContainer"} onClick={this.props.handler}>
        <div className="check">
          <input
            type="radio"
            data-validation={this.props.validate}
            name={this.props.name}
            value={this.props.value}
          />
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
              fill="#333333"
            />
          </svg>
        </div>
        <div className="radioLabel">{this.props.label}</div>
        <div className="clear"></div>
      </div>
    );
  }
}

export default FormRadioButton;



// WEBPACK FOOTER //
// ./src/components/dati_personali/components/FormRadioButton/index.js